<template>
    <div class="row pt-3 np-flex-1">
        <div class="col-3">
            <div class="np-header2 vertical-align-center pb-2">
                <svg class="me-2"><use href="@/assets/images/icons/pressure.svg#icon"></use></svg> {{ $t("UI.admin.availableDiskSpace") }}
            </div>  
            <div class="np-panel mb-3">
                <div class="np-panel-body p-4">
                    <div class="np-group np-group-column py-1">
                        <h3 class="np-header3 pb-4">{{ $t("UI.admin.usedSpace") }}</h3>                       
                        <div class="np-group np-group-column pb-4">
                            <span class="pb-2">80% {{ $t("UI.from") }} 2 GB</span>
                            <div class="np-progressbar">
                                <div class="np-progressbar-track np-progressbar-danger" :style="{'width': 80 +'%', 'max-width': '100%'}"></div>
                            </div> 
                        </div>
                        <span class="pb-4">{{ $t("UI.admin.used") }}: 1.75 GB</span>
                        <span>{{ $t("UI.admin.available") }}: 250 MB</span>
                    </div>
                </div>
            </div>   

            <div class="np-header2 vertical-align-center pt-1 pb-2">
                <svg class="me-2"><use href="@/assets/images/icons/license.svg#icon"></use></svg> {{ $t("UI.admin.licenseInfo") }}
            </div>  
            <div class="np-panel mb-3">
                <div class="np-panel-body p-4">
                    <div class="np-group np-group-column py-1">
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.licenseVersion") }}</h3>
                            <span>1.02025</span>
                        </div>  
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.licenseIssued") }}</h3>
                            <span>14.02.2025</span>
                        </div>  
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.licenseType") }}</h3>
                            <span>Корпоративная</span>
                        </div>  
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.licenseCount") }}</h3>
                            <span>2</span>
                        </div>                          
                        <div class="np-group np-group-column">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.licenseAvailable") }}</h3>
                            <span>1</span>
                        </div> 
                    </div>
                </div>
            </div>                                                              
        </div>

        <div class="col-6 d-flex flex-column h-100">
            <div class="np-header1 pb-4">{{ $t("UI.admin.tickets")}}</div>
            <div class="np-group np-group-column pt-2">
                <div class="np-group justify-content-between pb-3">
                    <div class="np-field-group np-with-icon-right flex-grow-1 me-2">
                        <input name="search-field" type="text" class="np-text-input np-outline" :placeholder="$t('search.search')"/>
                        <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                    </div>
                    <button class="np-btn np-outline me-2">
                        <svg><use href="@/assets/images/icons/filter.svg#icon"></use></svg>
                    </button>
                    <button class="np-btn np-outline">
                        <svg><use href="@/assets/images/icons/sorting.svg#icon"></use></svg>
                    </button>                    
                </div>          
            </div>
            <div class="np-panel np-flex-1">
                <div class="np-panel-body h-100 p-4">
                    <div class="np-group np-group-column py-1">
                        <PerfectScrollbar>
                            <ul class="np-list">
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-f-bold np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>
                                <li class="np-ticket p-3">
                                    <div class="np-group align-items-center w-100" role="button">
                                        <div class="np-group np-group-column flex-grow-1">
                                            <div class="np-group justify-content-start mb-3 w-100">
                                                <div class="np-font-ml np-color-freeze me-2">№820</div>
                                                <div class="np-font-ml np-f-bold np-color-primary me-2">Проблема с оплатой продвинутой версии</div>
                                                <div class="np-badge-s np-success-filled np-font-xs me-2">Открыт</div>
                                            </div>
                                            <div class="np-group align-items-center">
                                                <CobaltProfile 
                                                    firstName="Иван" 
                                                    lastName="Иванович" 
                                                    size="np-avatar-medium me-1"
                                                    :short="false"
                                                />
                                                <span class="ms-2">01.01.2025</span>
                                            </div>
                                        </div>
                                        <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                                    </div>
                                </li>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                            </ul>  
                        </PerfectScrollbar>   
                    </div>
                </div>
            </div>                               
        </div> 
        <div class="col-3">
            <div class="np-header2 vertical-align-center pb-2">
                <svg class="me-2"><use href="@/assets/images/icons/setting.svg#icon"></use></svg> {{ $t("UI.admin.users") }}
            </div>  
            <div class="np-panel mb-3">
                <div class="np-panel-body p-4">
                    <div class="np-group np-group-column py-1">
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.usersCount") }}</h3>
                            <span>25</span>
                        </div>                      
                        <div class="np-group np-group-column">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.usersOnline") }}</h3>
                            <span>1</span>
                        </div> 
                    </div>
                </div>
            </div>

            <div class="np-header2 vertical-align-center pb-2">
                <svg class="me-2"><use href="@/assets/images/icons/setting.svg#icon"></use></svg> {{ $t("UI.admin.statistics") }}
            </div>  
            <div class="np-panel mb-3">
                <div class="np-panel-body p-4">
                    <div class="np-group np-group-column py-1">
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.ticketsCount") }}</h3>
                            <span>25</span>
                        </div>  
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.ticketsClosed") }}</h3>
                            <span>14</span>
                        </div>  
                        <div class="np-group np-group-column pb-4">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.ticketsOpen") }}</h3>
                            <span>2</span>
                        </div>                       
                        <div class="np-group np-group-column">
                            <h3 class="np-header3 pb-2">{{ $t("UI.admin.averageAnswerTime") }}</h3>
                            <span>1</span>
                        </div> 
                    </div>
                </div>
            </div>                             
        </div>         
    </div>

</template>

<script>
import Config from '../../config'
import { useOrganizationStore } from '@/stores/organizationStore'
import CobaltProfile from '../dashboard/parts/CobaltProfile.vue' 
export default {
    components: {
        CobaltProfile
    },
    data() {
        return {
            Config
        }
    },
    async beforeMount() {
        await this.organizationStore?.init()
    },
    computed: {   
        organizationStore() {
            return useOrganizationStore()
        }                  
    },
    methods: {  
    }

}
</script>

<style>
</style>